<template>
  <v-dialog
    :value="active"
    width="90%"
    persistent
  >
    <v-card class="pa-6 text-center">
      <v-card-text>
        <DocumentosTable :documentos="documentos" />
      </v-card-text>
      <v-card-actions>
        <v-row>
          <v-col cols="12">
            <APrimaryButton
              label="Cerrar"
              @click="$emit('update:active', false)"
            />
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import APrimaryButton from '../atoms/APrimaryButton.vue';
import DocumentosTable from './DocumentosTable.vue';

export default {
  components: {
    APrimaryButton,
    DocumentosTable,
  },

  props: {
    active: {
      type: Boolean,
      required: true,
    },

    documentos: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      isLoading: false,
    };
  },
};
</script>
